import Cart from './components/Cart/Cart.vue'

const modals: KwixeoInterface.DynamicModals = [
  {
    key: 'cart',
    title: 'subscriptions.cart.title',
    component: Cart,
    size: 'xl',
    buttons: [
      {
        label: 'Fermer',
        variant: 'secondary',
        click: (modal: KwixeoInterface.DynamicModal, events: KwixeoInterface.DynamicModalButtonEvents): void => {
          events.close()
        },
        show: (modal: KwixeoInterface.DynamicModal): boolean => {
          const length = modal.value?.modules.length > 0
          modal.size = length ? 'xl' : 'md'
          return true
        }
      }
    ]
  }
]

export default modals
